import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  input,
  output,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModusSwitchModule } from '@trimble-gcs/modus';
import { Scan3dStyle } from '../../models/scan-3d-style';
import { Scan3dIntensityComponent } from '../scan-3d-intensity/scan-3d-intensity.component';
import { scan3dRgbTranslations } from './scan-3d-rgb.translations';

@UntilDestroy()
@Component({
  selector: 'sd-scan-3d-rgb',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSliderModule,
    Scan3dIntensityComponent,
    ModusSwitchModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './scan-3d-rgb.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Scan3dRgbComponent {
  readonly scan3dStyle = input.required<Scan3dStyle>();
  readonly styleChange = output<Partial<Scan3dStyle>>();

  readonly showIntensitySettings = computed(() => this.scan3dStyle().blendIntensity);

  readonly blendIntensityControl = new FormControl<boolean>(false);

  readonly translations = scan3dRgbTranslations();

  constructor() {
    this.subscribeToScan3dStyle();
    this.subscribeToFormValueChanges();
  }

  onStyleChange(style: Partial<Scan3dStyle>) {
    this.styleChange.emit(style);
  }

  private subscribeToScan3dStyle() {
    toObservable(this.scan3dStyle)
      .pipe(untilDestroyed(this))
      .subscribe((style) =>
        this.blendIntensityControl.setValue(style.blendIntensity, { emitEvent: false }),
      );
  }

  private subscribeToFormValueChanges() {
    this.blendIntensityControl.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe((blendIntensity) =>
        this.styleChange.emit({ blendIntensity: blendIntensity ?? false }),
      );
  }
}
